import { styled, BottomSheetContent as UiSidebarContent } from "@l2r-front/l2r-ui"

export const SidebarContent = styled(UiSidebarContent)({
    display: "flex",
    flexDirection: "column",
    position: "relative",
})